<script setup>
definePage({
  meta: {
    action: 'read',
    subject: 'assigntest',
  },
})

import { useBuildStore } from "@/utils/stores/build"
import { useESignatureStore } from "@/utils/stores/esignature"
import { useProjectStore } from "@/utils/stores/project"
import ESignature from "@/views/build/common/eSignature.vue"

// import Entree from "@/views/build/crf-page/entree.vue"
import { useAlertDialog } from '@/utils/stores/alertDialog'
import { useLoading } from '@/utils/stores/loading'
import RandomPage from "@/views/build/random/index.vue"
import StandardPage from "@/views/build/standard/index.vue"

const currentTab = ref('standard')
 
const loadingStore = useLoading() 
const esignatureStore = useESignatureStore()
const alertDialogStore = useAlertDialog()
const buildStore = useBuildStore()
const projectStore = useProjectStore()
const { isBuild } = storeToRefs(buildStore)

const projectLocked = ref(true)
const projectAnswered = ref(true)

// Backend에서 데이터 가져오기.
// get build data - schedule, cyclevisit, crfgroup, crfPage
// tab들은 pinia에서 동기화. save하면 DB에 저장하고...
// build 는 그때 저장하는 걸로.
buildStore.isBuild = false


const { data: project, error } = await useApi(createUrl(`/projects/${projectStore.projectId}`, {
  query: {
  },
}))



const loadBuild = async() => {
  const { data, error } = await useApi(createUrl('/build', {
    query: {
      projectId: projectStore.projectId,
    },
  }))

  if (error.value) {
    console.error(error.value)
  } else {
    if (data.value) {
      console.log(data.value)
      buildStore.crfGroup = (data.value.crfGroup)
      buildStore.cycleVisit = (data.value.cycleVisit)
      buildStore.schedule = (data.value.schedule)
      buildStore.uvSchedule = (data.value.uvSchedule)
      if (data.value && data.value.project) {
        buildStore.standard = Array.isArray(data.value.project.standard)
          ? data.value.project.standard // 이미 배열이면 그대로 사용
          : JSON.parse(data.value.project.standard) // 문자열이면 JSON 변환
      } else{
        buildStore.standard = []
      }

      projectLocked.value = !!(data.value.project.locked == 1)
      projectAnswered.value = !!(data.value.answers > 0)
    }
  }
}

loadBuild()

const toggleBuild = () =>{

  // modal
  esignatureStore.$reset()
  esignatureStore.isDialogVisible = true

  // buildStore.isBuild = !isBuild.value
}

const signConfirm = async ({ result }) => {

  if(result) {
    if(buildStore.isBuild) {
      // 선정제외기준은 standard-page API로 별도 저장되므로
      // build API 호출 시 skipReasonCheck 플래그 전달
      const store = await $api(`/build`, { method: 'POST',
        body: {
          projectId: projectStore.projectId,
          crfGroup: buildStore.crfGroup,
          cycleVisit: buildStore.cycleVisit,
          schedule: buildStore.schedule,
          uvSchedule: buildStore.uvSchedule,
          skipReasonCheck: true,
        } })

      buildStore.isBuild = false
    } else {
      // 저장처리...
      buildStore.isBuild = true
    }
  }
}

const downloadBlankPDF = async () =>{
  loadingStore.message = "요청중... 기다려주세요."
  loadingStore.isLoading = true

  const data = await $api(`/blank-crf`, { method: 'POST',
    responseType: "blob",
    body: {
      projectId: projectStore.projectId,
    } })

  // const url = window.URL.createObjectURL(new Blob([data]))
  // const link = document.createElement('a')

  // link.href = url
  // link.setAttribute('download', "blank-crf.pdf") //or any other extension
  // document.body.appendChild(link)
  // link.click()
  // window.URL.revokeObjectURL(url)
  // link.remove()
  loadingStore.isLoading = false
  alertDialogStore.showAlertDialog("요청이 완료되었습니다. 결과는 이메일로 전달됩니다.")
}
</script>

<template>
  <h3 class="text-lg font-semibold mb-8">
    시험군배정
  </h3>
  <ESignature @confirm="signConfirm" />
  <VRow v-if="currentTab !== 'random'">
    <VCol class="text-right">
      <VBtn
        v-if="isBuild"
        style="z-index: 10;"
        type="button"
        @click="toggleBuild"
      >
        적용
      </VBtn>
      <VBtn
        v-if="!isBuild && $can('write', 'assigntest')"
        style="z-index: 10;"
        type="button"
        :disabled="projectLocked"
        @click="toggleBuild"
      >
        <!-- || projectAnswered -->
        해제
        <VIcon
          v-if="projectLocked"
          end
          icon="tabler-lock"
        />
        <VIcon
          v-if="!projectLocked && projectAnswered"
          end
          icon="tabler-pencil"
        />
      </VBtn>
      <span><h4> &nbsp;</h4></span>
    </VCol>
  </VRow>
  <VRow
    v-if="currentTab == 'random'"
    style="position: relative;block-size:80px;"
  >
    <VCol
      class="
    text-right"
    />
    <span><h4> &nbsp;</h4></span>
  </VRow>
  <VRow style="position: relative;inset-block-start:-80px;">
    <VCol>
      <VTabs
        v-model="currentTab"
        class="v-tabs-pill"
      >
        <VTab
          v-if="project.project_v === '2'"
          value="standard"
        >
          {{ $t('Standard') }}  
        </VTab>
        <VTab
          v-if="project.project_v === '2'"
          value="random"
        >
          {{ $t('Random') }}
        </VTab>
      </VTabs>

      <VWindow
        v-model="currentTab"
        class="disable-tab-transition"
      >
        <VWindowItem
          v-if="project.project_v === '2'"
          key="window5"
          value="standard"
          k
        >
          <StandardPage />
        </VWindowItem>

        <VWindowItem
          v-if="project.project_v === '2'"
          key="window6" 
          value="random"
        >
          <RandomPage />
        </VWindowItem>
      </VWindow>
    </VCol>
  </VRow>
</template>



<style lang="scss" scoped> 
// 👉 Tab Pill
.v-tabs.v-tabs-pill {
  .v-slide-group-item--active.v-tab--selected {
    background-color: #6A78D3;
    color: white;
    font-weight: bold;
  }
}

.v-tabs.v-tabs-pill .v-tab.v-btn{
  border : 1px solid #6A78D3;
  color: #2F45B8;
  margin-inline-end: 10px;
}
</style>
